import { apiClient } from '_app'
import { ApiResponse, TitleProcessingStateDto } from 'dtos'

export const getTitleProcessingStates = () =>
  apiClient.get<ApiResponse<TitleProcessingStateDto[]>>('/api/title-processing-states').then(res => res.data)
